<template>
  <div class="is-inline">
      <div class="modal-card" style="max-height: none">
        <section class="modal-card-body has-background-color-background"
          v-if="this.ventes.length">
          <div class="columns mb-0">
            <div class="column is-2">
              <b-field>
                <b-autocomplete
                  v-model="search.name"
                  placeholder="Ex: AIX"
                  :open-on-focus="true"
                  :data="libelleDataFilter"
                  @select="option => selected = option">
                </b-autocomplete>
                <p class="control">
                  <a class="button is-default" @click="setSearch()">
                    <b-icon icon="magnify"></b-icon>
                  </a>
                </p>
              </b-field>
            </div>
            <div class="column is-one-fifth">
              <b-field>
                <b-select v-model="annee">
                    <option
                        v-for="n in 20"
                        :key="n"
                        :value="search.annee0 + n">
                        {{search.annee0 + n}}
                    </option>
                </b-select>
            </b-field>
            </div>
          </div>
          <nav class="level mb-15">
            <!-- Left side -->
            <div class="level-left">
              <div class="level-item">
                <p class="subtitle is-5">
                  {{cur + 1}} / {{dataFiltre.length}}
                </p>
              </div>
            </div>
            <div class="level-item">
              <button
                class="button"
                @click="update(-1)">
                <b-icon icon="chevron-left"></b-icon>
              </button>
              <div class="has-text-centered has-text-weight-semibold mx-10" v-if="dataFiltre[cur]">
                <p class="" v-if="dataFiltre[cur].libelle">
                  {{dataFiltre[cur].libelle}}
                </p>
                <p class="" v-if="dataFiltre[cur].nbFaces">
                  {{dataFiltre[cur].nbFaces}} FACES ({{dataFiltre[cur].format}})
                </p>
                <p class="is-uppercase" v-if="dataFiltre[cur].jourDepartLibelle">
                  DEPART LE {{dataFiltre[cur].jourDepartLibelle}}
                </p>
              </div>
              <button
                class="button"
                @click="update(1)">
                <b-icon icon="chevron-right"></b-icon>
              </button>
            </div>
            <!-- Right side -->
            <div class="level-right"></div>
          </nav>
          <div class="columns is-multiline" v-if="dataFiltre[cur]">
            <div class="column is-2 p-10" v-for="(month, i) in ventes" :key="i">
              <div class="card radius_card">
                <header class="card-header border_header">
                  <p class="card-header-title py-8">
                    {{months[i]}}
                  </p>
                </header>
                <div class="card-content is-paddingless">
                  <div class="content brb is-marginless" v-for="(vente, y) in month" :key="y"
                      :class="vente.class">
                    <div class="columns is-vcentered pointer" @click="clickCase(vente, i, y)">
                      <div class="column is-5">
                        <div class="has-text-centered border_b border_r">
                          S{{pad(vente.semaine)}}
                        </div>
                        <div class="has-text-centered border_b border_r">
                          {{vente.dateStart.day(dataFiltre[cur]
                            .jourDepartLibelle).format('DD-MMM')}}
                        </div>
                        <div class="has-text-centered border_r"
                          v-if="dataFiltre[cur].jourDepartLibelle">
                           {{dataFiltre[cur].jourDepartLibelle}}
                        </div>
                      </div>
                      <div class="column pl-0">
                        <p class="mb-0">{{vente.annonceur}}</p>
                        <p class="mb-0 is-size-7" v-if="vente.jourFerie">
                          {{vente.jourFerie.date.format('ddd DD-MMM')}}:
                          {{vente.jourFerie.nom_jour_ferie}}
                        </p>
                      </div>
                      <b-icon icon="check" class="mr-12" v-if="vente.check"></b-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
  </div>
</template>

<script>
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteReseauxTempo-mutation-type';
import decorateurRectangleReseauxTempo from '@/services/decorateur/decorateurRectangleReseauxTempo';
import getAnneeSemaine from '@/services/general/getAnneeSemaine';
import { getPropositions } from '@/api/reseaux/index';
import getJourFerie from '@/api/jourFerie/index';

const VenteReseauxTempo = createNamespacedHelpers('venteReseauxTempo');
const Panier = createNamespacedHelpers('panier');

export default {
  data() {
    return {
      isCardModalActive: false,
      cur: null,
      dataPropositions: {},
      num: 0,
      ventes: [],
      months: [
        'Janvier',
        'Février',
        'Mars',
        'Avril',
        'Mai',
        'Juin',
        'Juillet',
        'Août',
        'Septembre',
        'Octobre',
        'Novembre',
        'Décembre',
      ],
      search: {
        name: '',
        annee0: moment().add(-10, 'years').isoWeekYear(),
      },
      annee: moment().isoWeekYear(),
      dataFiltre: [],
      joursFerie: [],
      selected: null,
      isSelect: false,
      mountedLoadingEnd: false,
    };
  },
  watch: {
    reseauxWithFilter(val) {
      this.cur = 0;
      this.dataFiltre = val;
    },
    async cur() {
      if (!this.mountedLoadingEnd) return;
      await this.updateData();
    },
    async annee() {
      if (!this.mountedLoadingEnd) return;
      await this.updateData();
    },
    async dataFiltre() {
      if (!this.mountedLoadingEnd) return;
      await this.updateData();
    },
  },
  computed: {
    ...VenteReseauxTempo.mapGetters([
      'reseauxWithFilter',
      'criterePlanning',
    ]),
    ...Panier.mapGetters([
      'reseauxTempoPanier',
    ]),
    dateStart() {
      return moment(`01/01/${this.annee}`, 'DD/MM/YYYY');
    },
    dateEnd() {
      return moment(`31/12/${this.annee}`, 'DD/MM/YYYY');
    },
    disabledLeft() {
      if (this.cur === 0) return true;
      return false;
    },
    disabledRight() {
      if (this.cur === this.dataFiltre.length) return true;
      return false;
    },
    libelleDataFilter() {
      const nom = this.dataFiltre.map(el => el.libelle);
      return nom.filter((option) => {
        return option
          .toString()
          .toLowerCase()
          .indexOf(this.search.name.toLowerCase()) >= 0;
      });
    },
  },
  methods: {
    ...VenteReseauxTempo.mapActions({
      actionsGestionPanier: 'gestionPanier',
    }),
    ...VenteReseauxTempo.mapMutations({
      setReseauxSelected: types.SET_RESEAUX_SELECTED,
    }),
    async updateData() {
      if (this.dataFiltre.length === 0) return;
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const result = await getPropositions(
          this.dateStart.format('YYYYMMDD'),
          this.dateEnd.format('YYYYMMDD'),
          [this.dataFiltre[this.cur].num],
        );
        if (result) {
          if (this.joursFerie.length === 0 || this.joursFerie[0].date.year() !== this.annee) {
            this.joursFerie = await getJourFerie(this.annee);
          }
          this.dataPropositions = result.data;
          this.num = this.dataFiltre[this.cur].num;
          this.getVentesAnnuel();
        }
      } finally {
        loadingComponent.close();
      }
    },
    getVentesAnnuel() {
      const vm = this;
      if (!vm) { return; }
      const ventesArray = [];
      let dateVar = this.dateStart.clone();
      const color = [
        { color: '#2c3e50', fill: '#FFFFFF', stroke: '#49DB70' },
        { color: '#FFFFFF', fill: '#E43A45', stroke: '#E43A45' },
        { color: '#2c3e50', fill: '#FFFFFF', stroke: '#F89E37' },
        { color: '#2c3e50', fill: '#F8E810', stroke: '#F89E37' },
      ];
      while (dateVar < this.dateEnd) {
        const key = dateVar.isoWeekYear() + dateVar.isoWeek().toString().padStart(2, '0');
        if (vm === undefined) {
          dateVar = this.getDateVart(dateVar);
          /* eslint-disable no-continue */
          continue;
          /* eslint-enable no-continue */
        }
        if (vm.dataPropositions[vm.num] === undefined) {
          dateVar = this.getDateVart(dateVar);
          /* eslint-disable no-continue */
          continue;
          /* eslint-enable no-continue */
        }
        if (dateVar.isoWeeks() >= 52 && moment(dateVar).weekday() === 6) {
          dateVar = moment(dateVar).startOf('week');
        }
        const casePlanning = vm.dataPropositions[vm.num][key];
        const result = {};
        decorateurRectangleReseauxTempo(result,
          true,
          casePlanning,
          dateVar,
          vm.reseauxTempoPanier,
          vm.dataFiltre[vm.cur]);
        for (let i = 0; i < color.length; i += 1) {
          if (color[i].color === result.textColor &&
              color[i].fill === result.fill &&
              color[i].stroke === result.stroke) {
            result.class = `color${i + 1}`;
          }
        }
        const ferie = vm.joursFerie.find(el => el.date.isoWeek() === result.semaine);
        if (ferie) result.jourFerie = ferie;
        ventesArray.push(result);
        dateVar = this.getDateVart(dateVar);
      }
      const data = [];
      for (let i = 0; i < 12; i += 1) {
        const mount = ventesArray.filter(el => el.dateStart.month() === i);
        data.push(mount);
      }
      data.forEach((el) => {
        el.forEach((sr) => {
          const find = this.reseauxTempoPanier.find(res =>
            res.num === this.num && res.extensionOpportunite.semaine === sr.semaine);
          if (find) sr.check = true;
          else sr.check = false;
        });
      });
      vm.ventes = data;
      this.$emit('dataExport', {
        libelleReseau: this.dataFiltre[this.cur].libelle,
        data: data,
      });
    },
    pad(d) {
      return (d < 10) ? '0' + d.toString() : d.toString();
    },
    setSearch() {
      if (this.selected) {
        this.cur = this.dataFiltre.map(el => el.libelle).indexOf(this.selected);
      }
    },
    update(i) {
      this.cur += i;
      if (this.cur < 0) {
        this.cur = this.dataFiltre.length - 1;
        return;
      }
      if (this.cur > this.dataFiltre.length - 1) {
        this.cur = 0;
      }
    },
    async clickCase(vente, i, y) {
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        const key = getAnneeSemaine(vente.annee, vente.semaine);
        this.ventes[i][y].check = !vente.check;
        await this.actionsGestionPanier({
          resNum: this.num,
          semaine: vente.semaine,
          annee: vente.annee,
          dataPropositions: this.dataPropositions[this.num][key],
        });
        const reseauPanier = this.reseauxTempoPanier.find((el) => {
          return el.num === this.num;
        });
        this.setReseauxSelected({
          data: this.num,
          value: reseauPanier !== undefined && reseauPanier !== null,
        });
        loadingComponent.close();
      } catch (error) {
        loadingComponent.close();
        throw error;
      }
    },
    getDateVart(dateStart) {
      let dateVar = dateStart.clone();
      if (dateVar.isoWeeks() >= 52) {
        dateVar = dateVar.startOf('week').add(7, 'days');
      } else {
        dateVar = dateVar.add(7, 'days');
      }
      return dateVar;
    },
  },
  async mounted() {
    this.cur = 0;
    this.dataFiltre = this.reseauxWithFilter;
    await this.updateData();
    this.mountedLoadingEnd = true;
  },
};
</script>




// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxTempo/recherche/vueGlobalPanning.vue